import { RouteConfig } from "vue-router";

const proveedores: RouteConfig = {
  path: "/proveedores",
  name: "proveedores",
  component: () => import(/* webpackChunkName: "proveedores" */ "@/views/Proveedores.vue"),
};

export default proveedores;
